(()=>{
  const openPaloma=()=>{
    const paloma=document.querySelector("qadar-paloma-entry");
    if(paloma&&typeof paloma.open==="function"){
      paloma.open();
      return;
    }
    document.querySelector(".qadar-paloma-entry__tab[data-paloma-open]")?.click();
  };

  const makeAccess=(prompt,placement)=>{
    const wrap=document.createElement("div");
    wrap.className="qb-vibe__paloma-access"+(placement==="result"?" qb-vibe__paloma-access--result":"");
    wrap.dataset.qbPalomaAccess=placement;
    const copy=document.createElement("p");
    copy.textContent=prompt;
    const button=document.createElement("button");
    button.type="button";
    button.className="qb-vibe__paloma-button";
    button.dataset.qbPalomaOpen="true";
    button.textContent="ASK PALOMA";
    wrap.append(copy,button);
    return wrap;
  };

  const init=()=>{
    const root=document.querySelector(".qb-vibe");
    if(!root)return;

    const chooser=root.querySelector(".qb-vibe__chooser");
    if(chooser&&!chooser.querySelector('[data-qb-paloma-access="chooser"]')){
      chooser.appendChild(makeAccess("Want help choosing?","chooser"));
    }

    if(root.dataset.qbPalomaAccessReady!=="true"){
      root.dataset.qbPalomaAccessReady="true";
      root.addEventListener("click",event=>{
        const button=event.target.closest("[data-qb-paloma-open]");
        if(!button)return;
        event.preventDefault();
        openPaloma();
      });
    }
  };

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
  document.addEventListener("shopify:section:load",init);
})();
